import React, { useEffect, useState } from 'react';
import { Button } from '../ui/Button';
import { TrophyIcon, Flame, Lock, AlertTriangleIcon, UserIcon, ArrowRightIcon, CheckCircleIcon, ZapIcon } from 'lucide-react';
import { CountdownTimer } from '../ui/CountdownTimer';
import { ScarcityBadge } from '../ui/ScarcityBadge';
export const Hero: React.FC = () => {
  const [copiesLeft, setCopiesLeft] = useState(187);
  useEffect(() => {
    const interval = setInterval(() => {
      setCopiesLeft(prev => {
        if (prev > 172) return prev - 1;
        return prev;
      });
    }, 30000);
    return () => clearInterval(interval);
  }, []);
  return <section className="py-12 md:py-16 relative overflow-hidden" data-id="element-132">
      {/* Subtle background elements */}
      <div className="absolute -top-24 -right-24 w-96 h-96 bg-gradient-to-br from-[#E0B84C]/10 to-transparent rounded-full blur-3xl" data-id="element-133"></div>
      <div className="absolute -bottom-32 -left-32 w-96 h-96 bg-gradient-to-tr from-[#E0B84C]/5 to-transparent rounded-full blur-3xl" data-id="element-134"></div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center relative z-10" data-id="element-135">
        {/* Left column - Text content */}
        <div className="flex flex-col items-center md:items-start text-center md:text-left order-2 md:order-1 space-y-6" data-id="element-136">
          {/* Premium Scarcity Badge */}
          <ScarcityBadge data-id="element-137" />
          {/* Main heading - simplified */}
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold" data-id="element-138">
            <span className="bg-gradient-to-r from-[#E0B84C] to-[#FFD700] bg-clip-text text-transparent" data-id="element-139">
              Cristiano Ronaldo
            </span>
            <div className="mt-1 bg-gradient-to-r from-[#E0B84C] to-[#FFD700] bg-clip-text text-transparent" data-id="element-140">
              La Leyenda en Edición Limitada
            </div>
          </h1>
          {/* Main description - simplified */}
          <div className="space-y-3 max-w-2xl" data-id="element-141">
            <p className="text-lg sm:text-xl text-[#CFCFCF]" data-id="element-142">
              <span className="underline decoration-[#E0B84C] decoration-2 underline-offset-4" data-id="element-143">
                No estás comprando un libro.
              </span>{' '}
              Estás reclamando una{' '}
              <span className="font-bold text-white" data-id="element-144">reliquia mental</span> que
              transformará tu vida.
            </p>
            <p className="text-base text-gray-400" data-id="element-145">
              Cristiano Ronaldo no solo hizo historia…{' '}
              <span className="text-white font-medium" data-id="element-146">
                La rediseñó desde dentro.
              </span>{' '}
              Y ahora puedes sostener una parte de esa historia — no en tus
              manos, sino{' '}
              <span className="italic text-[#E0B84C]" data-id="element-147">
                en tu mente para siempre
              </span>
              .
            </p>
          </div>
          {/* Countdown timer - centered and symmetrical */}
          <div className="w-full flex flex-col items-center" data-id="element-148">
            <CountdownTimer className="mx-auto mb-3" data-id="element-149" />
            <p className="text-sm text-[#FF3B30] font-medium text-center" data-id="element-150">
              ⚠️ OFERTA EXPIRA CUANDO EL CONTADOR LLEGUE A CERO
            </p>
          </div>
          {/* Primary CTA - centered and more prominent */}
          <div className="w-full flex justify-center" data-id="element-151">
            <Button className="text-base px-8 py-3.5 w-full sm:w-4/5 md:w-auto flex items-center justify-center gap-2 transform hover:scale-105 transition-all duration-300" href="https://store.collectiondigital.vip/cart/45861496684706:1" id="cta-download" trackClick={true} data-id="element-152">
              <TrophyIcon className="w-5 h-5 flex-shrink-0" data-id="element-153" />
              <span className="whitespace-nowrap font-bold" data-id="element-154">
                DESCARGA AHORA
              </span>
              <ArrowRightIcon className="w-5 h-5 ml-1 flex-shrink-0" data-id="element-155" />
            </Button>
          </div>
          {/* Trust badges - centered on mobile, left on desktop */}
          <div className="flex flex-wrap justify-center md:justify-start gap-4" data-id="element-156">
            <div className="flex items-center gap-2 text-gray-300" data-id="element-157">
              <CheckCircleIcon className="w-4 h-4 text-[#22C55E] flex-shrink-0" data-id="element-158" />
              <span className="text-sm" data-id="element-159">Entrega instantánea</span>
            </div>
            <div className="flex items-center gap-2 text-gray-300" data-id="element-160">
              <Lock className="w-4 h-4 text-[#E0B84C] flex-shrink-0" data-id="element-161" />
              <span className="text-sm" data-id="element-162">Compra 100% segura</span>
            </div>
            <div className="flex items-center gap-2 text-gray-300" data-id="element-163">
              <ZapIcon className="w-4 h-4 text-[#E0B84C] flex-shrink-0" data-id="element-164" />
              <span className="text-sm" data-id="element-165">Acceso de por vida</span>
            </div>
          </div>
          {/* Social proof - simplified */}
          <div className="bg-[#0A0A0A]/40 border border-[#E0B84C]/30 rounded-full px-4 py-2 flex items-center text-sm" data-id="element-166">
            <UserIcon className="w-4 h-4 text-[#22C55E] mr-2 flex-shrink-0" data-id="element-167" />
            <span className="text-[#22C55E]" data-id="element-168">
              <span className="font-bold" data-id="element-169">
                {Math.floor(Math.random() * 5) + 3} personas
              </span>{' '}
              han comprado en la última hora
            </span>
          </div>
        </div>
        {/* Right column - Ebook cover - simplified */}
        <div className="relative order-1 md:order-2" data-id="element-170">
          <div className="relative aspect-[4/5] overflow-hidden rounded-lg border-2 border-[#E0B84C] shadow-xl transform hover:scale-[1.02] transition-transform duration-500" data-id="element-171">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uJuyemTbQnHQG1gPrPEuq5/Screenshot_2025-09-29_at_11.31.49_AM.png" alt="Cristiano Ronaldo - La Leyenda - Edición Limitada" className="w-full h-full object-contain bg-black" loading="eager" data-id="element-172" />
            {/* Limited edition badge */}
            <div className="absolute top-4 right-4 bg-[#E0B84C] text-black font-bold px-4 py-2 rounded-full transform rotate-12 shadow-lg text-sm" data-id="element-173">
              EDICIÓN LIMITADA
            </div>
          </div>
        </div>
      </div>
      {/* Legal disclaimer - simplified */}
      <div className="mt-8 text-xs text-center text-gray-500 max-w-3xl mx-auto" data-id="element-174">
        <p data-id="element-175">
          ⚠️ Las imágenes son ilustraciones artísticas estilizadas, no
          fotografías oficiales. Arte conceptual creado por fans.
        </p>
      </div>
    </section>;
};